// Selectors used for the image-compare functionality
const selectors = {
  imageContainer: ".image-compare__image-container",
  labelContainer: ".image-compare__label-container",
  slider: ".image-compare__slider",
};

// Function to initialize the image-compare slider
function initImageCompare(container) {
  const imageContainer = container.querySelector(selectors.imageContainer);
  const labelContainers = container.querySelectorAll(selectors.labelContainer);
  const slider = container.querySelector(selectors.slider);

  if (!slider || !imageContainer) {
    console.error("Image Compare: Required elements not found.");
    return;
  }

  // Slider input event to adjust image position
  const updateSliderPosition = (event) => {
    const position = `${event.target.value}%`;
    imageContainer.style.setProperty("--position", position);
  };

  // Hide label containers
  const hideLabels = () => {
    labelContainers.forEach((label) => {
      label.style.opacity = "0";
    });
  };

  // Show label containers
  const showLabels = () => {
    labelContainers.forEach((label) => {
      label.style.opacity = "1";
    });
  };

  // Attach event listeners to the slider
  slider.addEventListener("input", updateSliderPosition);
  slider.addEventListener("mousedown", hideLabels);
  slider.addEventListener("touchstart", hideLabels);
  slider.addEventListener("mouseup", showLabels);
  slider.addEventListener("touchend", showLabels);

  // Return a cleanup function to remove event listeners
  return () => {
    slider.removeEventListener("input", updateSliderPosition);
    slider.removeEventListener("mousedown", hideLabels);
    slider.removeEventListener("touchstart", hideLabels);
    slider.removeEventListener("mouseup", showLabels);
    slider.removeEventListener("touchend", showLabels);
  };
}

// Function to initialize animation for the image compare section
function animateImageCompare(container) {
  const observer = new IntersectionObserver(
    (entries, observerInstance) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          container.classList.add("is-visible");

          // Remove animation class after animation completes
          setTimeout(() => {
            container.classList.remove("animation--image-compare");
          }, 1200);

          observerInstance.disconnect();
        }
      });
    },
    { threshold: 0.5 }
  );

  observer.observe(container);

  // Cleanup function to disconnect observer
  return () => observer.disconnect();
}

// Main registration function for the "image-compare" section
function registerImageCompare(container) {
  let cleanupAnimation = null;
  let cleanupSlider = null;

  // Initialize sliders
  cleanupSlider = initImageCompare(container);

  // Initialize animation if applicable
  if (container.classList.contains("should-animate")) {
    cleanupAnimation = animateImageCompare(container);
  }

  // Return an unload function to clean up resources
  return () => {
    if (cleanupSlider) cleanupSlider();
    if (cleanupAnimation) cleanupAnimation();
  };
}

// Example usage: Initialize all elements with the "image-compare" class
document.querySelectorAll(".image-compare").forEach((container) => {
  const cleanup = registerImageCompare(container);

  // Handle cleanup when needed, for example, during page navigation
  // cleanup();
});
